module.exports = __webpack_public_path__ + "static/media/kuaraHorizontal.94ec26f5.svg";